import './index.scss';
import Loader from 'react-loaders'
import AnimatedLetters from '../AnimatedLetters';
import { useEffect , useRef, useState } from 'react';
import emailjs from '@emailjs/browser'
import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'


const Contact =() => {
    const [letterClass, setLetterClass] = useState('text-animate')
    const form = useRef()
    const contactArray = 'Contact Me'.split('')

  useEffect(() => {
    const timer = setTimeout(() => {
      setLetterClass('text-animate-hover')
    }, 2000)
    return () => clearTimeout(timer)
  }, [])

  const sendEmail = (e) => {
    e.preventDefault()
    emailjs.sendForm('service_tdj3nyo', 'template_g7jqnyz', form.current, 'v7j4oB702zRx6kqTA')
    .then(
      () => {
        // alert('Message successfully sent!')
        toast.success('Message successfully sent!', {
          position: 'bottom-center',
          autoClose: 3500,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: 'dark',
        })
        const timeout = setTimeout(() => {
          window.location.reload(false)
        }, 3900)

        return () => clearTimeout(timeout)
      },
      () => {
        // alert('Failed to send the message, please try again')
        toast.error('Failed to send the message, please try again', {
          position: 'bottom-center',
          autoClose: 3500,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: 'dark',
        })
      }
    )
}

    
    return (
        <>
        <div className='container contact-page'>
            <div className='text-zone'>
                <h1>
                <AnimatedLetters
                letterClass={letterClass}
                strArray={contactArray}
                idx={15}
                
              />
                </h1>
                <p>
                    I am intrested in freelancing opportunities - especially ambitous
                    or large projects. it can be on full stack or designing , if 
                    you have request or quetions, don't be think of it just do it 
                    bruh 😁😁😎😉
                </p>
                <div className='contact-form'>
                    <form ref={form} onSubmit={sendEmail}>
                        <ul>
                            <li className="half">
                                <input type="text" name="user_name" placeholder='Name' required />
                            </li>
                            <li className="half">
                                <input 
                                type="email" 
                                name="user_email"
                                placeholder="Email"
                                required 
                                />
                            </li>
                            <li>
                                <input 
                                placeholder="Subject" type="text" name="subject" />
                            </li>
                            <li>
                                <textarea placeholder="Message" name="message" required >

                              </textarea>
                            </li>
                            <li>
                                <input type="submit" className='flat-button' value="SEND" />
                    
                            </li>
                            
                        </ul>
                        <ToastContainer />
                    </form>
                </div>


            </div>
        </div>
        <Loader type="pacman"/>
        
        </>

 
    )
}

export default Contact